import { render, staticRenderFns } from "./AgreementsBuilder.vue?vue&type=template&id=2d1366b8&scoped=true"
import script from "./AgreementsBuilder.vue?vue&type=script&lang=js"
export * from "./AgreementsBuilder.vue?vue&type=script&lang=js"
import style0 from "./AgreementsBuilder.vue?vue&type=style&index=0&id=2d1366b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1366b8",
  null
  
)

export default component.exports